export default ({audienceChartData, audienceBgColor, engagementData, engagementBgColor}) => ({
    initDemographicsChart() {
        const ctx = document.getElementById('demographics-chart');

        const borderColor = {
            light: '#ffffff',
            dark: '#150d1c',
        }

        const appearanceMode = document
            .querySelector('meta[name="appearance-mode"]')
            .getAttribute("content");

        const canApplyTheme = appearanceMode === 'true';

        const currentTheme = canApplyTheme ? window.currentTheme() : 'light';

        audienceBgColor[currentTheme];
        engagementBgColor[currentTheme];

        window.Chart.getChart('demographics-chart')?.destroy();

        new window.Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: ['Female', 'Male'],
                datasets: [
                    {
                        label: 'Demographics',
                        data: audienceChartData,
                        backgroundColor: audienceBgColor[currentTheme],
                        borderColor: borderColor[currentTheme],
                    },
                    {
                        label: 'Engagement',
                        data: engagementData,
                        backgroundColor: engagementBgColor[currentTheme],
                        borderColor: borderColor[currentTheme],
                        cutout: '55%',
                        radius: '90%'
                    },
                ],
            },
            options: {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    },
                },
                responsive: true,
                maintainAspectRatio: true,
            }
        });
    },
    init() {
        this.$nextTick(() => {
            this.initDemographicsChart();
        });

        window.addEventListener('change-appearance-mode', () => {
            this.initDemographicsChart();
        });

        window.addEventListener('system-appearance-mode-changed', () => {
            this.initDemographicsChart();
        });
    }
});
